import { useEffect } from "react";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    if (description) {
      upsert("name", "description", description);
      upsert("property", "og:title", title);
      upsert("property", "og:description", description);
    }
  }, [title, description]);
  return null;
}
